module.exports = __webpack_public_path__ + "static/media/03. Keluarga Kita.48c14a8f.png";